import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { createDS, PblNgridColumnSet, PblNgridRowContext } from '@pebula/ngrid';
import { PblDetailsRowToggleEvent } from '@pebula/ngrid/detail-row';
import { UnRx } from '@pebula/utils';

@Component({
  selector: 'sg-inspector-files-table',
  templateUrl: './inspector-files-table.component.html',
  styleUrls: ['./inspector-files-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
@UnRx()
export class SgInspectorFilesTableComponent<T> implements OnInit {
  @Input() columns: PblNgridColumnSet;
  @Input() tableData$: Subject<Array<T>>;
  @Input() fileContent$: Subject<string>;
  @Output() onClickRow = new EventEmitter<string>();
  @Output() onClickDownloadFile = new EventEmitter<string>();

  selectedFileContent$ = new Observable<string>();
  isLoading$ = new Subject<boolean>();
  isDetailRowOpen = false;
  filesContentCache = new Map<string, string>();
  selectedFile: any;

  dataSource = createDS<T>()
    .onTrigger((event) => this.tableData$)
    .create();

  constructor() {}

  ngOnInit(): void {
    this.selectedFileContent$ = this.fileContent$.pipe(
      UnRx(this),
      tap((fileContent) => {
        this.filesContentCache.set(this.selectedFile?.id, fileContent);
        this.isLoading$.next(false);
      })
    );
  }

  detailRowClicked($event: PblDetailsRowToggleEvent): void {
    this.selectedFile = $event.row;
    if (this.filesContentCache.has(this.selectedFile?.id)) {
      this.fileContent$.next(this.filesContentCache.get(this.selectedFile.id));
    } else {
      this.isLoading$.next(true);
      this.onClickRow.emit(this.selectedFile?.id);
    }
    this.isDetailRowOpen = $event.expended;
  }

  evenRowClassUpdate(context: PblNgridRowContext): string {
    if (context.index % 2 === 0) {
      return 'even-row-index';
    }
  }
}
